module.exports = __webpack_public_path__ + "01_mole.c236ac54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/01_mole.png
// module id = vDS3
// module chunks = 0